import { WhiteCard } from './WhiteCard';
import { WildCard } from './WildCard';
import { selectionOrder } from '../../state/cardSelection';

interface CardHandItem {
  id: string;
  text: string;
  type?: 'white' | 'wild';
}

interface CardHandProps {
  cards: CardHandItem[];
  selectedIds?: readonly string[];
  onToggle?: (id: string) => void;
  showWild?: boolean;
}

export function CardHand({ cards, selectedIds = [], onToggle }: CardHandProps) {
  // Outer scrolls; inner is `w-max mx-auto` so it centers when the hand fits and
  // stays fully reachable (no left-edge clipping) when it overflows. Using
  // `justify-center` directly on a scroll container clips the first cards off the
  // left where they can't be scrolled into view.
  return (
    <div className="w-full overflow-x-auto custom-scrollbar" role="region" aria-label="Your cards. Scroll horizontally to see your full hand." tabIndex={0}>
      <div className="flex items-end gap-2 md:gap-3 w-max mx-auto px-4 pt-6 pb-2">
          {cards.map((card) => {
          const order = selectionOrder(selectedIds, card.id);
          const isSelected = order !== null;
          if (card.type === 'wild') {
            return (
              <WildCard
                key={card.id}
                testId="hand-card"
                compact
                selected={isSelected}
                orderLabel={order ?? undefined}
                onClick={onToggle ? () => onToggle(card.id) : undefined}
                className="flex-shrink-0"
              />
            );
          }
          return (
            <WhiteCard
              key={card.id}
              testId="hand-card"
              text={card.text}
              compact
              selected={isSelected}
              orderLabel={order ?? undefined}
              onClick={onToggle ? () => onToggle(card.id) : undefined}
              className="flex-shrink-0"
            />
          );
        })}
      </div>
    </div>
  );
}
